export { default } from './LayoutLandingPage';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/index.js